//Loading reducer
export const APP_LOADING_START = 'APP_LOADING_START';
export const APP_LOADING_END = 'APP_LOADING_END';

export const CLEAR_STATE = 'CLEAR_STATE';
